// m-type-pill.component.ts
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

// Styles
import { colors } from '@design-system/styles/colors';

// Types
import { TypePillSize } from './m-type-pill.component.types';
import { NgClass, NgStyle } from '@angular/common';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'm-type-pill',
  templateUrl: './m-type-pill.component.html',
  styleUrls: ['./m-type-pill.component.scss'],
  imports: [NgClass, NgStyle]
})
export class MTypePillComponent {
  @Input() size: TypePillSize = TypePillSize.default;
  @Input() text = '';
  @Input() iconName: string | undefined = undefined;
  @Input() iconFilled = false;
  @Input() secondaryColor = colors['orange-200'];
  @Input() backgroundColor = colors['gray-100'];
  @Input() borderColor = colors['gray-400'];

  readonly tagSize = TypePillSize;
}
